import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";
import { useDnDBypassContext } from "@/components/builder/utils/bypass-context";

import BasePreview from "../../../base";

function FormRadioMultiLabelPreview({ ...props }) {
  const { data: { value } } = useDnDBypassContext()
  return <BasePreview {...props}>
    <p>{value?.label}</p>
  </BasePreview>
}

export default define('form-radio-multi-label', FormRadioMultiLabelPreview, Fragment)
  .shared(prop.share('FormRadioMultiLabel', 'form-radio-multi-label'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .build()
